// src/pages/Gratitudejournals/index.jsx  (jahan bhi original file hai)
import React, { useEffect, useState } from "react";
import CollectionPage from "./CollectionPage";
import { getGratitudeJournals, PRODUCTS_PER_PAGE } from "../data/Gratitudejournals";
import SEOHead from "../components/common/SEOHead";
import ProductListSchema from "../components/common/ProductListSchema";
import FAQSchema from "../components/common/FAQSchema";

const PAGE_URL = "https://aishcraft.com/gratitude-journals";

const gratitudeJournalFAQs = [
  {
    question: "What is a gratitude journal used for?",
    answer: "A gratitude journal helps you reflect daily by noting things you're thankful for, improving mindfulness and mental wellbeing.",
  },
  {
    question: "Can I personalize the gratitude journal with my name?",
    answer: "Yes, every journal can be customized with your name, initials, or a custom message on the cover.",
  },
  {
    question: "How long does delivery take?",
    answer: "Personalized journals are made to order and typically ship within 6 working days across India.",
  },
];

export default function Gratitudejournals() {
  const [products, setProducts] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getGratitudeJournals()
      .then(setProducts)
      .catch((err) => setError(err.message || "Failed to load products"));
  }, []);

  const seo = (
    <SEOHead
      title="Gratitude Journals | Personalized Journals"
      description="Shop 300+ beautifully designed personalized gratitude journals. Premium quality, customizable — perfect for daily reflection."
      url={PAGE_URL}
      breadcrumbs={[
        { name: "Home", item: "https://aishcraft.com/" },
        { name: "Gratitude Journals", item: PAGE_URL },
      ]}
    />
  );

  if (error) {
    return (
      <>
        {seo}
        <div className="min-h-screen flex items-center justify-center text-red-600">{error}</div>
      </>
    );
  }

  if (!products) {
    return (
      <>
        {seo}
        <div className="min-h-screen flex items-center justify-center text-gray-500">Loading...</div>
      </>
    );
  }

  const config = {
    products,
    productsPerPage: PRODUCTS_PER_PAGE,
    basePath: "/gratitude-journals",
    announcement: {
      headline: "Get 20% Off the new 2026 Planners!",
      subtext: "300+ designs to personalise • No code required",
    },
    hero: {
      title: " Journals",
      subtitle: "Pages for seamless planning",
      featuredIn: ["PREMIUM QUALITY", "TRUSTED CRAFTSMANSHIP", "PAN INDIA DELIVERY"],
      quote: "This planner makes me so organised and looks so pretty on my desk! My fav undated planner yet!",
      quoteLink: "#",
      rating: "4.7",
      ratingCount: "1000+",
    },
  };

  return (
    <>
      {seo}
      <ProductListSchema products={products} pageUrl={PAGE_URL} />
      <FAQSchema faqs={gratitudeJournalFAQs} />
      <CollectionPage config={config} />
    </>
  );
}